/**
 * Оформительские изображения главной страницы (редизайн 2026-10, DESIGN_SYSTEM §5.4, §7.1).
 *
 * Это иллюстрации hero, а не автомобили каталога: карточки берут снимки из
 * `/media/` через API (FE-051). Файлы лежат в `public/editorial/` и уезжают в
 * сборку, поэтому отдаются с того же origin — внешних запросов на главной нет,
 * и production-CSP (`img-src 'self' data:`) выполняется без исключений.
 *
 * Источники — в [PHOTO-CREDITS.md](../../../../PHOTO-CREDITS.md).
 *
 * Размеры — собственные размеры файлов: атрибуты `width`/`height` резервируют
 * место под изображение до загрузки, и раскладка не прыгает.
 *
 * **alt-тексты обязаны описывать то, что на изображении.** Если файл заменили,
 * ключ `home.hero.karlImageAlt` меняется вместе с ним: alt, обещающий не то, что
 * видно, — это ложные сведения для тех, кто пользуется скринридером.
 */
export const EDITORIAL_PHOTOS = {
  /**
   * Karl — **сгенерированный образ AI-помощника, а не фотография сотрудника**,
   * вырезан по силуэту, фон прозрачный: свечение `--glow-karl` строится по
   * альфа-каналу. Низ куртки срезан краем кадра — фигура стоит на нижней
   * границе hero.
   */
  karl: { src: '/editorial/karl.webp', width: 687, height: 1024 },
  /** Салон, горизонтальный кадр: фон hero от 768 px. Декоративный, alt пустой. */
  showroomWide: { src: '/editorial/showroom-wide.webp', width: 1024, height: 572 },
  /** Салон, вертикальный кадр: фон hero на телефоне. Декоративный, alt пустой. */
  showroomTall: { src: '/editorial/showroom-tall.webp', width: 572, height: 1024 },
} as const;

/**
 * С какой ширины hero берёт горизонтальный кадр салона. Совпадает с границей
 * раскладки в `HomePage.module.css` (768 px, DESIGN_SYSTEM §4.4): телефон
 * получает только вертикальный кадр и широкий не качает.
 */
export const HERO_BACKDROP_WIDE_MEDIA = '(min-width: 768px)';
